// extracted by mini-css-extract-plugin
export default {"button":"af6b04a2b387f90ff999f62155874165"};